<script setup>
  import { computed, onMounted, ref } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useFilterStore } from '@/stores/filter'
  import ExportPdf from '@/components/Utility/ExportPdf.vue'
  import DataGridFilterMultiple from '@/components/Landingpage/DataGridFilterMultiple.vue'
  import DataGridFilterSingle from '@/components/Landingpage/DataGridFilterSingle.vue'
  import DataGridItem from '@/components/Landingpage/DataGridItem.vue'

  const store = useFilterStore()
  const itemsReady = ref(false)
  const { items, filters } = storeToRefs(store)
  const multipleFilters = ref(false)

  const hasPdfDownload = computed(() => {
    return props.pdfDownload
  })

  const props = defineProps({
    type: String,
    content: String,
    pdfDownload: String,
    filter: String,
    gridClasses: String
  })

  onMounted (async () => {
    await store.setItems(props.content, props.type)
    if (props.filter && props.filter.length > 0) {
      await store.setFilters(props.filter)
    }
    if (filters.value && filters.value.length > 0) {
      multipleFilters.value = await store.hasMultipleFilters
    }

    itemsReady.value = true
  })

  const filteredItems = computed(() => {
    return store.getItems(props.type)
  })

</script>

<template>
  <div
    class="data-grid"
  >
    <div
      v-if="filters && filters.length > 0"
      class="data-grid-filters"
    >
      <DataGridFilterSingle
        v-if="!multipleFilters"
        :filter="filters[0]"
      />
      <DataGridFilterMultiple
        v-else
        :filters="filters"
      />
    </div>
    <ExportPdf
      v-if="hasPdfDownload && itemsReady"
      :items="filteredItems"
    />
    <div
      class="data-grid-items grid"
      v-if="itemsReady"
      :class="gridClasses"
    >
      <DataGridItem
        v-for="item in filteredItems"
        :key="item.id"
        :item="item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
